import { useEffect, useState } from 'react';

const useFilteredData = ({
  data,
  option
}: {
  data: any | null | undefined;
  option: any[];
}) => {
  const [filteredCategory, setFilteredCategory] = useState<any | undefined>(
    undefined
  );

  useEffect(() => {
    if (data !== undefined && option) {
      const filteredData = option.filter((item: any) => item.value === data);
      if (filteredData.length > 0) {
        setFilteredCategory(filteredData[0]);
      } else {
        setFilteredCategory(undefined);
      }
    } else {
      setFilteredCategory(undefined);
    }
  }, [data, option]);

  return filteredCategory;
};

export default useFilteredData;
